module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsSAAALEgHS3X78AAAAp0lEQVRIie2Sfw2DMBCFvzmYBCQgYRKQMAmTMAeTwCTgAByAAyR0DrZc8kia8qPdn1vuSxpK817fXXM4juP8H6dMRw1Qa/8CBmAqfAXznoFnidhCZuC9sez8psuO/EHe+kC3Etv3AdyBNiki6DwNNv8oTV/S3SIed7podFEc3EZFhYx/Vd3ybDnxJQmOV7/n3xqaqwaky1UnKoVX+u++GCzHcZyfB/gAdKkxqevR3DQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/ic_date.png
// module id = 148
// module chunks = 0